import type { SVGProps } from 'react';

const SvgHomeOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="vuesax/outline/home">
      <g id="home">
        <path
          id="Vector"
          d="M11.7333 15.0405H4.26662C3.05329 15.0405 1.94662 14.1071 1.74663 12.9071L0.859957 7.60048C0.719957 6.77381 1.11996 5.71381 1.77996 5.18715L6.39997 1.48711C7.2933 0.767114 8.69996 0.773788 9.59996 1.49379L14.22 5.18715C14.8733 5.71381 15.2733 6.77381 15.14 7.60048L14.2533 12.9071C14.0533 14.0871 12.9266 15.0405 11.7333 15.0405ZM7.9933 1.96046C7.63997 1.96046 7.28662 2.06711 7.02662 2.27378L2.40663 5.97381C2.02663 6.28048 1.76663 6.96044 1.84663 7.44044L2.7333 12.7471C2.8533 13.4471 3.55329 14.0405 4.26662 14.0405H11.7333C12.4466 14.0405 13.1466 13.4471 13.2666 12.7404L14.1533 7.43381C14.2333 6.95381 13.9666 6.26714 13.5933 5.96714L8.9733 2.27378C8.70663 2.06711 8.3533 1.96046 7.9933 1.96046Z"
          fill="#94969C"
        />
        <path
          id="Vector_2"
          d="M7.99998 10.8335C6.80665 10.8335 5.83331 9.86012 5.83331 8.66679C5.83331 7.47346 6.80665 6.50012 7.99998 6.50012C9.19331 6.50012 10.1666 7.47346 10.1666 8.66679C10.1666 9.86012 9.19331 10.8335 7.99998 10.8335ZM7.99998 7.50012C7.35998 7.50012 6.83331 8.02679 6.83331 8.66679C6.83331 9.30679 7.35998 9.83346 7.99998 9.83346C8.63998 9.83346 9.16665 9.30679 9.16665 8.66679C9.16665 8.02679 8.63998 7.50012 7.99998 7.50012Z"
          fill="#94969C"
        />
      </g>
    </g>
  </svg>
);
export default SvgHomeOutline;
